<template>
  <div>
    <div class="fixed-top">
      <LobbyNavbar />
    </div>

    <div class="container" style="margin-top:88px">
      <p>&zwnj;</p>

      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/Home">
              <span class="text-primary">
                Home
              </span>
            </router-link>
          </li>

          <li class="breadcrumb-item active" aria-current="page">Online Events</li>
        </ol>
      </nav>
      <p>&zwnj;</p>

      <div>
        <div class="title_fontStyle  h2"><i class="fas fa-caret-right"></i> Online Events</div>
        <h5 class="mt-5">Continuously brings in trends, technologies, and issues discussed by industry experts.</h5>
        <p>&zwnj;</p>

        <div class="row ">
          <div class="col-md-4 mb-4">
            <router-link to="/ProductLaunch">
              <img
                src="../../assets/images/ProductLaunchOverlay.jpg"
                class="EventBanner brightnessHover img-fluid"
                alt=""
              />
            </router-link>
          </div>

          <div class="col-md-4 mb-4">
            <router-link to="/Association">
              <img
                src="../../assets/images/AssociationOverlay1.jpg"
                class="EventBanner brightnessHover img-fluid "
                alt=""
              />
            </router-link>
          </div>

        
        </div>
        <p>&zwnj;</p>
      </div>
    </div>
  </div>
</template>

<script>
  import LobbyNavbar from '@/components/LobbyNavbar.vue'
  import $ from 'jquery'
  import { mapGetters } from 'vuex'

  export default {
    components: {
      LobbyNavbar,
    },

    data() {
      return {
        token: '',
      }
    },

    computed: {
      ...mapGetters(['ListStatus', 'Roomvisible', 'ShowRoom', 'exhcode']),
    },

    methods: {},

    created() {
      $('.modal').modal('hide')
      const vm = this
      this.$store.dispatch('ShowChatRoom', false)

      this.$store.dispatch('updateList', false)
      this.$store.dispatch('Updatevisible', true)

      //紀錄瀏覽

      vm.$http.get(`https://www.chanchao.com.tw/apiOnlineExpo/v1/CSRF_Token`).then((response) => {
        let CSRFToken = response.data

        let NowPageUrl = location.href

        const url = `https://www.chanchao.com.tw/apiOnlineExpo/v1/OrganizerLog/${vm.exhcode}`
        const info = {
          Type: '',
          ID: '',
          Url: NowPageUrl,
          CSRF: CSRFToken,
        }
        vm.$http.post(url, info).then(function(response) {
          if (response.data == '200') {
            console.log('Log success')
          } else if (response.data == '251') {
            console.log('Log fail')
          }
        })
      })
    },
  }
</script>

<style lang="scss" scoped>
  .EventBanner {
    transition: all 0.3s;
    background-size: cover;
    background-repeat: no-repeat;
    border: 1px solid gray;
    border-radius: 10px;
  }
</style>
